<template>
    <div class="row instagram-content-suggestion">
        <div class="col-md-12">
            <div class="row" v-if="suggestion">
                <div class="col-md-7">
                    <div id="carouselExampleIndicators" class="carousel slide" data-ride="carousel">
                        <div class="carousel-inner">
                            <div class="carousel-item active">
                                <img class="img-fluid"  style="width:100%; height: auto;" :src="suggestion.imageUrl" alt="First slide">
                            </div>
                        </div>
                        <a class="carousel-control-prev" href="#carouselExampleIndicators" role="button" data-slide="prev" v-on:click="changePage(page - 1)">
                            <span class="carousel-control-prev-icon" aria-hidden="true"></span>
                            <span class="sr-only">Previous</span>
                        </a>
                        <a class="carousel-control-next" href="#carouselExampleIndicators" role="button" data-slide="next" v-on:click="changePage(page + 1)">
                            <span class="carousel-control-next-icon" aria-hidden="true"></span>
                            <span class="sr-only">Next</span>
                        </a>
                    </div>
                </div>
                <div class="col-md-5">
                    <div class="previous-suggestion-btn"></div>
                    <div class="row mb-3">
                        <div class="col-md-12 suggestion-title mb-3">Caption</div>
                        <div class="col-md-12">
                            {{suggestion.caption}}
                        </div>
                    </div>
                    <div class="row mb-3">
                        <div class="col-md-12 suggestion-title mb-3">Posted by</div>
                        <div class="col-md-12">
                            <a target="_blank" :href="'https://www.instagram.com/' + suggestion.profile.userName">@{{suggestion.profile.userName}}</a>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-md-12 suggestion-title mb-3">Engagement Rate</div>
                        <div class="col-md-12">
                            {{(suggestion.engagementRate * 100).toFixed(1)}}%
                        </div>
                    </div>
                </div>
                <div class="col-md-12 mt-5">
                    <div class="row">
                        <div class="col-md-12">
                            <div class="input-group mb-3">
                                <input type="text" class="form-control" v-model="imageCaption" placeholder="Enter a quote">
                                <div class="input-group-append">
                                    <button class="btn btn-primary" v-on:click="captionImage" type="button">Apply quote</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import InstagramService from '../../services/instagram-service'
    import BarChart from '../charts/bar-chart'
    import InstagramMixin from "./InstagramMixin";

    export default {
        components: { BarChart },
        mixins: [InstagramMixin],
        data() {
            return {
                imageCaption: Spark.state.currentTeam.name,
                suggestion: null,
                page: 1
            }
        },
        computed: {
        },
        methods: {
            changePage(page) {
                if (page === 0) return

                this.page = page
                this.getSuggestions()
            },
            async getSuggestions(initial = false){
                this.loading = true

                if (initial) {
                    this.selectedHashtags = this.jwtHashtags
                    this.selectedProfiles = this.profileIDs
                }

                const params = {
                    filters: {},
                    from: this.dateRange.startDate,
                    to: this.dateRange.endDate,
                    page: this.page
                }

                if (!this.selectedHashtags.length) {
                    params.filters.hashtags = this.jwtHashtags
                } else {
                    params.filters.hashtags = this.selectedHashtags
                }

                params.filters.locations = this.selectedLocations
                params.filters.profileIDs = this.selectedProfiles

                const suggestion = await InstagramService.suggestions.index(params)

                this.suggestion = suggestion.data
                this.loading = false
            },
            async captionImage() {
                this.loading = true

                await InstagramService.suggestions.create({
                    imageUrl: this.suggestion.imageUrl,
                    caption: this.imageCaption
                })

                this.loading = false
            }
        },
        async mounted() {
            this.getSuggestions(true)
        }
    }
</script>
